import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ArrowDownwardAltProps = IconComponentBaseProps;

export const ArrowDownwardAlt = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.blue[6],
}: ArrowDownwardAltProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4130_41713"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill={fill} />
      </mask>
      <g mask="url(#mask0_4130_41713)">
        <path
          d="M7.50016 9.86417V4C7.50016 3.85811 7.54805 3.73933 7.64383 3.64367C7.7395 3.54789 7.85827 3.5 8.00016 3.5C8.14205 3.5 8.26083 3.54789 8.3565 3.64367C8.45227 3.73933 8.50016 3.85811 8.50016 4V9.86417L10.7155 7.64867C10.8078 7.55644 10.9239 7.50922 11.0637 7.507C11.2033 7.50489 11.3215 7.55211 11.4182 7.64867C11.5147 7.74533 11.563 7.86244 11.563 8C11.563 8.13756 11.5147 8.25467 11.4182 8.35133L8.422 11.3475C8.30144 11.4679 8.16083 11.5282 8.00016 11.5282C7.8395 11.5282 7.69889 11.4679 7.57833 11.3475L4.58216 8.35133C4.48994 8.259 4.44272 8.14294 4.4405 8.00317C4.43839 7.8635 4.48561 7.74533 4.58216 7.64867C4.67883 7.55211 4.79594 7.50383 4.9335 7.50383C5.07105 7.50383 5.18816 7.55211 5.28483 7.64867L7.50016 9.86417Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
